var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content fba-order" },
    [
      _c(
        "order-grid",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.view === "list",
              expression: "view==='list'"
            }
          ],
          ref: "orderGrid",
          attrs: { "view-source": "fbaVerify", "config-module": "102" },
          on: {
            refusePermission: _vm.refusePermission,
            reviewRefusePermission: _vm.reviewRefusePermission,
            rowDoubleClicked: function($event) {
              return _vm.toLook()
            }
          }
        },
        [
          _c(
            "div",
            { attrs: { slot: "operations" }, slot: "operations" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "look", type: "success" },
                  on: {
                    click: function($event) {
                      return _vm.toLook()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.look")))]
              ),
              false
                ? _c(
                    "el-button",
                    {
                      attrs: { no: "new", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.toAdd()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                  )
                : _vm._e(),
              false
                ? _c(
                    "el-button",
                    {
                      attrs: { no: "clone", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.toCopy()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Clone")))]
                  )
                : _vm._e(),
              _vm.$checkPermission(["button_FBAVerify_acceptFbaBookingOrder"])
                ? _c(
                    "el-button",
                    {
                      attrs: { no: "approved", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.toApproved()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.PassAudit")))]
                  )
                : _vm._e(),
              _vm.$checkPermission(["button_FBAVerify_rejectFbaBookingOrder"])
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        no: "refuse",
                        type: "primary",
                        disabled: _vm.rejectWindow.refuseState
                      },
                      on: {
                        click: function($event) {
                          return _vm.toRefuse()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Refuse")))]
                  )
                : _vm._e(),
              _vm.isPretrialReviewFBA &&
              _vm.$checkPermission([
                "button_FBAVerify_reviewThroughFbaBookingOrder"
              ])
                ? _c(
                    "el-button",
                    {
                      attrs: { no: "reApproved", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.toReApproved()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.VerifyReviewThrough")))]
                  )
                : _vm._e(),
              _vm.isPretrialReviewFBA &&
              _vm.$checkPermission([
                "button_FBAVerify_reviewRefusalFbaBookingOrder"
              ])
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        no: "reRefuse",
                        type: "primary",
                        disabled: _vm.reviewRefuseState
                      },
                      on: {
                        click: function($event) {
                          return _vm.toReRefuse()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.VerifyReviewRefusal")))]
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _c("order-workspace", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "detail",
            expression: "view==='detail'"
          }
        ],
        ref: "orderWorkspace",
        attrs: { "parent-context": _vm.context, "view-source": "fbaVerify" },
        on: { back: _vm.backToList, copy: _vm.toCopy }
      }),
      _vm.opVerifyFrameDialog.visible
        ? _c("fba-op-verify-frame-dialog", {
            attrs: {
              visible: _vm.opVerifyFrameDialog.visible,
              "job-model": _vm.opVerifyFrameDialog.job || {},
              "job-list": _vm.opVerifyFrameDialog.jobList || [],
              "submit-call-back": _vm.opVerifyFrameDialog.submitCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.opVerifyFrameDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.rejectWindow.visible
        ? _c("op-verify-frame-reject", {
            attrs: {
              visible: _vm.rejectWindow.visible,
              "job-no": _vm.rejectWindow.jobNo,
              type: "fba",
              "reject-call-back": _vm.rejectWindow.rejectCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.rejectWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("job-copy-window", {
        attrs: { visible: _vm.copyDialog.visible, lob: "fba" },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.copyDialog, "visible", $event)
          },
          confirmCallBack: _vm.doCopyJob
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }